import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RoutingService } from '@nano/common/routing';
import { SseService } from '@nano/core/sse';
import { ScreenSize, getScreenSize, screenSizeEqOrLessThan } from '@nano/common/util';
import { MessageService, MessageThread } from '@nano/common/message';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.less'],
  standalone: false
})
export class MessagesComponent implements OnInit, OnDestroy {
  messageThreads$: Observable<MessageThread[]>;
  selectedMessageThreadId: string;

  isMobile: boolean;
  private destroyed$: Subject<void> = new Subject();
  private breakpointSubscription: Subscription;

  constructor(
    private sseService: SseService,
    private route: ActivatedRoute,
    private routingService: RoutingService,
    private messageService: MessageService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.messageThreads$ = this.messageService.messageThreads$;
    this.route.params.pipe(takeUntil(this.destroyed$)).subscribe((params: Params) => (this.selectedMessageThreadId = params.id as string));
    this.messageService.messageThreadRemoved$.pipe(takeUntil(this.destroyed$)).subscribe(() => (this.selectedMessageThreadId = null));
    this.sseService.incomingMessage$.pipe(takeUntil(this.destroyed$)).subscribe(() => this.messageService.loadAllMessageThreads());
  }

  ngOnInit(): void {
    this.messageService.loadAllMessageThreads();
    this.breakpointSubscription = getScreenSize(this.breakpointObserver).subscribe((screenSize: ScreenSize) => {
      this.isMobile = screenSize === ScreenSize.XS;
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  selectMessageThread(id: string): void {
    this.routingService.navigateToMessageThreadDetails(id);
  }

  startMessageThread(): void {
    this.routingService.navigateToStartMessageThread();
  }

  isMessageThreadSelectionVisible(): boolean {
    return !this.isMobile || !this.selectedMessageThreadId;
  }

  isMessageThreadDetailsVisible(): boolean {
    return !this.isMobile || !!this.selectedMessageThreadId;
  }

  @HostListener('window:resize') onWindowResize(): void {
    this.checkIsMobile();
  }

  private checkIsMobile(): void {
    this.isMobile = screenSizeEqOrLessThan(ScreenSize.XS, this.breakpointObserver);
  }
}
